import { RETRY_LATER } from '../../../services/common/appConstants'

const traceHttp = false

/**
 * @name restArgs Builds the fetch request for a rest operation.
 * @param {string} method Method such as POST, GET.
 * @param {object} body Body for the request.
 * @param {object} headers request header info
 * @returns {object} The fetch request object.
 */
const restArgs = (method, body, headers) => {
  if (method === 'GET') {
    return {
      method,
      headers: headers
    }
  }
  return {
    method,
    body: JSON.stringify(body),
    headers: headers
  }
}

/**
 * 
 * @param {object} response  fetch response info
 * @param {string} url url info for error login
 * @param {number} localHttpId logId
 * @param {number} startTime method start time  
 * @returns {object} response object
 */
const handleResponse = async (response, url, localHttpId, startTime) => {
  // if (traceHttp && response.ok) {
  //   console.log(`restOperation complete url=${url}, httpId=${localHttpId}, ${new Date().getTime() - startTime} ms.`)
  // } else {
  //   if (traceHttp) {
  //     console.log(response)
  //   }
  // }
  if (response.status === 404) {
    throw new Error(RETRY_LATER)
  }
  let jsonResponse
  try {
    jsonResponse = await response.json()
  } catch (ex) {
    // const message = `handleResponse json parse error', status=${response.status}, statusText=${response.statusText || ''}, url=${response.url}`
    if (traceHttp) {      
      // console.log(message)
    }
    throw new Error(ex)
  }

  return jsonResponse
}


let httpId = 0

/**
 * 
 * @name restOperation
 * @param {string} url complete URL
 * @param {string} method  GET/POST method type
 * @param {object} body  body content 
 * @param {object} headers request header info
 * @returns {object} return json response
 */
export const restOperation = (url, method, body, headers) => {
  // console.log('restOperation')
  const localHttpId = httpId++
  const startTime = new Date().getTime()
  if (traceHttp) {
    // console.log(`restOperation started url=${url}, httpId=${localHttpId}.`)
    // console.log('restArgs')
    // console.log(restArgs(method, body, headers))
  }
  const args = restArgs(method, body, headers)
  // console.log(args)
  return fetch(url, args).then(response => handleResponse(response, url, localHttpId, startTime))
}

/**
 * @name get Performs a rest get operation.
 * @param {string|string[]|Promise<any>} url endpoint for the request if string. 
 * Array of endpoints for the request if array of strings. Finally, if Promise<any>
 * then a promise that is a service call. 
 * @param {object} reqHeaders request header info
 * @returns {Promise<any>} The fetch result promise.
 */
export const get = async (url, reqHeaders) => {
  let result
  if (typeof url === 'string') {
    result = await restOperation(url, 'GET', {}, reqHeaders)
  } else if (Array.isArray(url)) {
    const calls = []
    for (let i = 0; i < url.length; ++i) {
      calls.push(restOperation(url[i], 'GET', {}, reqHeaders))
      result = await Promise.all(calls)
    }
  } else {
    result = await url()
  }
  return result
}

/**
 * @name post Performs a rest post operation.
 * @param {string} url endpoint for the request.
 * @param {any} postObj Body for the request.
 * @returns {Promise<any>} The fetch result promise.
 */

/**
 * @name post
 * @param {string} url complete URL
 * @param {object} postObj body content
 * @param {headers} headers header info
 * @returns {object} response 
 */
export const post = async (url, postObj, headers) => {
  const result = await restOperation(url, 'POST', postObj, headers)
  return result
}

/**
 * @name del Performs a rest del operation.
 * @param {string} url endpoint for the request.
 * @returns {Promise<any>} The fetch result promise.
 */
export const del = url =>
  restOperation(url, 'DELETE')
